module.exports = __webpack_public_path__ + "static/media/waves.2e65f61b.PNG";